import { useState, useCallback } from 'react';

export function useToggle(initialValue = false) {
  const [value, setState] = useState(initialValue);
  const toggleValue = useCallback(() => setState((prevState) => !prevState), []);
  const setValue = useCallback((v: boolean) => setState(v), []);
  return { value, toggleValue, setValue };
}
